import { ProfilePushSection } from 'src/services/applications/applications.types';

// JT1-1808: i18n key for each section's label in the push dialog.
export const PROFILE_PUSH_SECTION_LABEL_KEY: Record<ProfilePushSection, string> = {
  [ProfilePushSection.DETAILS]: 'candidates.profile_push.sections.details',
  [ProfilePushSection.EXECUTIVE_SUMMARY]: 'candidates.profile_push.sections.executive_summary',
  [ProfilePushSection.WORK_EXPERIENCES]: 'candidates.profile_push.sections.work_experiences',
  [ProfilePushSection.EDUCATION_HISTORY]: 'candidates.profile_push.sections.education_history',
  [ProfilePushSection.SALARY_EXPECTATIONS]: 'candidates.profile_push.sections.salary_expectations',
  [ProfilePushSection.SKILLS]: 'candidates.profile_push.sections.skills',
  [ProfilePushSection.CURRENT_INFORMATION]: 'candidates.profile_push.sections.current_information',
  [ProfilePushSection.PREFERENCES]: 'candidates.profile_push.sections.preferences',
  [ProfilePushSection.LINKS]: 'candidates.profile_push.sections.links',
};

/** What a resume import can change on the candidate record. It never writes links. */
export const IMPORT_PUSH_SECTIONS: ProfilePushSection[] = [
  ProfilePushSection.DETAILS,
  ProfilePushSection.EXECUTIVE_SUMMARY,
  ProfilePushSection.WORK_EXPERIENCES,
  ProfilePushSection.EDUCATION_HISTORY,
  ProfilePushSection.SKILLS,
  ProfilePushSection.SALARY_EXPECTATIONS,
  ProfilePushSection.CURRENT_INFORMATION,
  ProfilePushSection.PREFERENCES,
];

const SECTION_VALUES = Object.values(ProfilePushSection) as string[];

/** The profile editor reports a save under a plain string; only some of them can be pushed. */
export const isProfilePushSection = (value: string): value is ProfilePushSection => SECTION_VALUES.includes(value);
